<template>
  <div class="indexTool">
    <a-spin :spinning="spinning" size="large" tip="加载中...">
    <div class="reply" ref="replayModal">
      <a-modal
        v-model:visible="addVisible"
        :title="title"
        @ok="handleOk"
        destroyOnClose="true"
        width="60%"
        :afterClose="afterClose"
        :getContainer="() => $refs.replayModal"
        wrapClassName="full-modal"
      >
          <a-transfer
                :data-source="mockData"
                show-search
                  :filter-option="(inputValue, item) => item.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1"
                :target-keys="targetKeys"
                :render="item => item.title"
                @change="handleChange1"
            >
          <template
            #children="{
            direction,
            filteredItems,
            selectedKeys,
            onItemSelectAll,
            onItemSelect,
            }"
        >
        <a-table
        :row-selection="getRowSelection({  selectedKeys, onItemSelectAll, onItemSelect })"
          :columns="direction === 'left' ? leftColumns : rightColumns"
        :data-source="filteredItems"
           size="small"
        />
      </template>
            </a-transfer>
      </a-modal>
    </div>
    <headerComponent></headerComponent>
    <div class="content">
      <div class="headerContent">
        <a-breadcrumb class="bgCrumb">
          <a-breadcrumb-item>
            <a @click="qxreturn"> 首页 </a>
          </a-breadcrumb-item>
          <a-breadcrumb-item class="two">
            {{ curTitle }}
          </a-breadcrumb-item>
          <!-- <a-breadcrumb-item>List</a-breadcrumb-item>
                <a-breadcrumb-item>App</a-breadcrumb-item> -->
        </a-breadcrumb>
        <div class="tip">{{ curName }}</div>
        <div class="data-list">
          <div class="label">添加对比</div>
          <!-- <div class="list isFoused"  v-for="list in wordList" :key="list">
                       {{list.name}}<CloseOutlined @click.stop="removeItem($event,list.id)" />
                    </div> -->
          <div class="list">
            {{ word }}
          </div>
          <div
            class="list"
            :style="{ color: list.color, borderColor: list.color }"
            v-for="list in extrWordList"
            :key="list"
          >
            {{ list.text }}<CloseOutlined @click.stop="removeItem($event, list.color)" />
          </div>
          <!-- <div class="list focused" v-if="list.isFoused==1" @click="addItem($event)" v-for="list in wordList" :key="list">
                       {{list.name}}<CloseOutlined @click.stop="removeItem($event,list.id)" />
                    </div> -->
          <!-- <div class="list">
                        关键词1<CloseOutlined @click="removeItem($event,list.id)" />
                    </div> -->
          <div class="last-list" @click="addWord"><PlusOutlined />添加关键词</div>
          <a-button class="foucus" v-if="showBtn1" v-show="showBtn" @click="addItem"
            >+ 关注</a-button
          >
          <a-button class="foucus" v-if="showBtn1" v-show="!showBtn" @click="removeItem1"
            >取消关注</a-button
          >
        </div>
      </div>
      <div class="part">
        <div class="part-header">
          <div class="label">搜索指数</div>
          <a-form-item label="选择日期：">
            <a-range-picker
              @openChange="onOpenChange"
              allowClear
              inputReadOnly
              @calendarChange="onCalendarChange"
              @change="panelChange"
              v-model:value="value3"
            >
              <template #suffixIcon>
                <CalendarOutlined />
              </template>
            </a-range-picker>
          </a-form-item>
        </div>
        <div class="part-content">
          <div class="part1">
            <a-select v-model:value="typeListCur" ref="select" @change="handleChange">
              <a-select-option v-for="li in selectColumns" :key="li.id" :value="li.name">{{li.name}}</a-select-option>
              <!-- <a-select-option value="weiboList">微博指数</a-select-option>
              <a-select-option value="wechatList">微信指数</a-select-option> -->
            </a-select>
            <div class="dataList">
              <!-- <div class="list active">30天</div>
                             <div class="list">14天</div>
                             <div class="list">7天</div> -->
              <img
                class="share"
                @click="exportpic('main')"
                src="../../assets/image/share.png"
                alt=""
              />
            </div>
          </div>
          <div class="main" id="main" v-if="alive"></div>
          <div class="tableContain">
            <div class="downContain">
              <div class="download" @click="exportCsv()">下载</div>
            </div>
            <a-table
              @change="handleTableChange"
              :dataSource="dataSource"
               :pagination="{
                        current: focusCurrent,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showQuickJumper: true,
                        total: focusTotal,
                        onChange: changePage,
                     }"
              bordered
              :columns="columns"
            >
             <template #receiveData="{ text }">
               {{formatDate(text)}}
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    </a-spin>
    <div class="hoverBottomWapper">
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>

  </div>
</template>

<script>
import headerComponent from '../../components/indexHeader'
import Papa from 'papaparse'
import { difference } from 'lodash-es';
import * as echarts from 'echarts'
import { CloseOutlined, PlusOutlined, CalendarOutlined } from "@ant-design/icons-vue"
import { getIndexDetail, getAllWordList, addWordListIndex, getWordList, removeWordListIndex,getInfoList } from '../../utils/api'
import { message } from 'ant-design-vue'
import { color } from 'echarts'
import moment from 'moment'
export default {
  components: {
    headerComponent,
    CloseOutlined,
    PlusOutlined,
    CalendarOutlined
  },
  data () {
    return {
      selectColumns:[],
      value3: '',
       leftColumns:[{
          dataIndex: 'title',
          title: '关键词',
      }],
      rightColumns:[{
          dataIndex: 'title',
          title: '关键词',
      }],
      focusCurrent:1,
      focusTotal:0,
      addVisible: false,
      showBtn: false,
      spinning:true,
      alive: true,
      showBtn1: false,
      value1: '1',
      dataLength: 30,
      extrWordList: [],
      disabledList: [],
      word: this.$route.query.word ? this.$route.query.word : '',
      dataSource: [
        //   {
        //     key: '1',
        //     name: '胡彦斌',
        //     age: '2020-03-15',
        //     address: '212',
        //     wechat:'10',
        //     weibo:'2'
        //   },
        //   {
        //     key: '2',
        //     name: '胡彦祖',
        //     age: '2020-03-19',
        //     address: '1221',
        //     wechat:'10',
        //     weibo:'2'
        //   },
      ],
      baiduList: [],
      weiboList: [],
      wechatList: [],
      curName: "",
      typeListCur: "",
      dataList: [],
      keyWordList: [],
      wordList: [],
      mockData: [],
      defaultData: [],
      curStateList:[],
      targetKeys: [],
      currentId: '',
      title: '添加关键词',
      startDate: '',
      endDate: '',
      legendDataList: [],
      curTitle: '',
      colorList: ['#0056FF', '#FF1E68', '#B3CCFF', '#B6023B'],
      myChart: null,
      dates: [],
      echartsList: ['#00A346', '#0056FF', '#FF1E68', '#B3CCFF', '#B6023B'],
      curEchartsList: ['#00A346'],
      currentIndex: '',
      columns: [
        {
          title: '关键词',
          dataIndex: 'keyword',
          sorter: (a, b) => a.keyword.localeCompare(b.keyword),
          key: 'keyword',
        },
        {
          title: '日期',
          dataIndex: 'receiveData',
          align: 'right',
          sorter: (a, b) => a.receiveData.localeCompare(b.receiveData),
          key: 'receiveData',
          slots: { customRender: 'receiveData' },
        },
        // {
        //   title: '百度指数',
        //   dataIndex: '百度指数',
        //   sorter: true,
        //   align: 'right',
        //   key: '百度指数',
        // },
        // {
        //   title: '微信指数',
        //   dataIndex: '微信指数',
        //   sorter: true,
        //   align: 'right',
        //   key: '微信指数',
        // },
        // {
        //   title: '微博指数',
        //   dataIndex: '微博指数',
        //   align: 'right',
        //   sorter: true,
        //   key: '微博指数',
        // },
      ],
    }
  },
  methods: {
      getRowSelection({ selectedKeys, onItemSelectAll, onItemSelect }) {
      return {
        // getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      }},
    handleSearch(dir, val){
      let that = this;
      if(dir=="left"){
        that.mockData = []
        if(val==''){
          that.mockData = that.defaultData
          return
        }
        getAllWordList(val.toLowerCase()).then(res=>{
          res.rows.map((cur,index)=>{
            that.mockData.push({
                key: index,
                title: cur.keyword,
                chosen: false,
              })
          })
        })
      }
    },
    filterOption(input, option) {
        return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    newSort (x, y) {
      return parseInt(x[this.currentIndex].toString().replace(/,/g, "")) - parseInt(y[this.currentIndex].toString().replace(/,/g, ""))
    },
    newSort1 (x, y) {
      return parseInt(y[this.currentIndex].toString().replace(/,/g, "")) - parseInt(x[this.currentIndex].toString().replace(/,/g, ""))
    },
    formatDate (str) {
      return str.substring(0, 4) + '-' + str.substring(4, 6) + '-' + str.substring(6, 8)
    },
    handleTableChange (pagination, filters, { field, order }) {
      this.currentIndex = field
      if (order == 'descend') {
        this.dataSource.sort(this.newSort)
      } else {
        this.dataSource.sort(this.newSort1)
      }
    },
    showClose (val) {
      if (this.$route.query.type == '0' && val == 0) {
        return false
      } else {
        return true
      }
    },
    disabledDate (current) {
      // return current > moment(new Date(new Date().getTime()-24*60*60*1000)) || current < moment(this.fun_date(91), 'YYYYMMDD')
      //   if (!this.dates.value || this.dates.value.length === 0) {
      //     return false
      //   }
      //   const diffDate = current.diff(this.dates.value[0], 'days')
      //   return Math.abs(diffDate) > 7
      if (!this.value3){
        return false; //开始和结束日期都未选择则所有日期都可以选
      }
      // return current > moment(new Date(new Date().getTime()-24*60*60*1000)) || current < moment(this.fun_date(91), 'YYYYMMDD')
      // 如果优先选择开始日期，根据当前为日期表还是月份表，利用monent的diff计算可选日期和开始时间的差值，返回boolean类型
      const startDay = moment(this.value3[0],'YYYYMMDD')
      const endDay = moment(this.value3[1],'YYYYMMDD')
      const tooLate = startDay&& (current.diff(startDay, 'days') > 91)
      // 如果优先选择结束日期，同样根据当前为日期表还是月份表，利用monent的diff计算可选日期和开始时间的差值，返回boolean类型
      const tooEarly = endDay && (endDay && endDay.diff(current, 'days') > 91)
      return !!tooEarly || !!tooLate;
    },
    onOpenChange (open) {
      if (open) {
        this.dates.value = []
      }
    },
    onCalendarChange (val) {
      this.dates.value = val
    },
    async getIndex () {
      let that = this
      await getAllWordList().then(res => {
        if (res.total != 0) {
          // that.hotWord = res.rows
          res.rows.map((cur, index) => {
            if (cur.keyword != that.word) {
              that.mockData.push({
                key: index,
                title: cur.keyword,
                chosen: false,
              })
            }
            that.defaultData.push({
              key: index,
              title: cur.keyword,
              chosen: false
            })
          })
          // that.mockData.map((cur,index)=>{
          //     that.word.split(',').forEach(function(_cur){
          //         if(_cur==cur.title){
          //             that.targetKeys.push(cur.key)
          //         }
          //     })
          // })
          console.log(that.mockData)
        } else {
        }
      })
    },
    exportpic (val) {
      let myChart = echarts.init(document.getElementById(val))
      let picInfo = myChart.getDataURL({
        type: 'png',
        pixelRatio: 1.5,  //放大两倍下载，之后压缩到同等大小展示。解决生成图片在移动端模糊问题
        backgroundColor: '#fff'
      })//获取到的是一串base64信息
      const elink = document.createElement('a')
      elink.download = this.word + '指数趋势图'
      elink.style.display = 'none'
      elink.href = picInfo
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    getTime (value) {
      var date = value//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours())
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      let strDate = Y + M + D + h + m + s
      return strDate
    },
    exportCsv () {
      let dataArr = []
      let that = this
      this.dataSource.map((cur,index)=>{
          dataArr.push({
            关键词:cur.keyword,
            日期:cur.receiveData
          })
      })
      this.dataSource.map((cur,index)=>{
        that.selectColumns.map((_cur,_index)=>{
          dataArr[index][_cur.name] = cur[_cur.name]
        })
      })
      console.log(dataArr)
      var csv = Papa.unparse(dataArr)
      //定义文件内容，类型必须为Blob 否则createObjectURL会报错
      let content = new Blob(['\uFEFF' + csv], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8' })
      //生成url对象
      let urlObject = window.URL || window.webkitURL || window
      let url = urlObject.createObjectURL(content)
      //生成<a></a>DOM元素
      let el = document.createElement("a")
      //链接赋值
      el.href = url
      let str = ''
      str = this.word + ','
      this.extrWordList.map((cur) => {
        str = str + cur.text + ","
      })
      str = str.substring(0, str.length - 1)
      el.download = str + '_指数详情' + ".csv"
      //必须点击否则不会下载
      el.click()
      //移除链接释放资源
      urlObject.revokeObjectURL(url)
    },
    handleOk () {
      let that = this
      // if(this.targetKeys.length==0){
      //     message.fail('请选择关键词')
      //     return
      // }
      // debugger
      that.extrWordList = []
      that.curEchartsList = ["#00A346"]
      // that.dataSource = []
      // this.word = this.$route.query.word;
      let str1 = this.word + ','
      this.spinning = true;
      that.targetKeys.map((cur, index) => {
        that.mockData.map((_cur) => {
          if (_cur.key == cur) {
            str1 = str1 + _cur.title + ','
            that.extrWordList.push({
              text: _cur.title,
              color: that.colorList[that.extrWordList.length]
            })
            // that.curEchartsList.push(that.echartsList[that.extrWordList.length])
          }
        })
        // that.curEchartsList = that.curEchartsList
        that.colorList.map((cur)=>{
          that.curEchartsList.push(cur)
        })
      console.log(that.curEchartsList)
      })
      str1 = str1.substring(0, str1.length - 1)
      // this.word =  str1;
      this.addVisible = false
      this.getDetail(str1, this.startDate, this.endDate,this.typeListCur)
    },
    qxreturn () {
      this.alive = false
      this.$router.push('indexList')
    },
    panelChange (val, mode) {
      this.startDate = mode[0].replace(/-/g, '')
      this.endDate = mode[1].replace(/-/g, '')
      this.dataSource = []
      this.keyWordList = []
      this.wechatList = []
      this.weiboList = []
      this.baiduList = []

      let str = ''
      str = this.word + ','
      this.extrWordList.map((cur) => {
        str = str + cur.text + ","
      })
      str = str.substring(0, str.length - 1)

      if (val.length==0){
        message.warn('请选择时间')
        return false
      }

      if (val[1].diff(val[0], 'days') > 91){
        message.warn('最多选择3个月时间')
        return false
      }
      this.spinning = true
      this.getDetail(str, this.startDate, this.endDate,this.typeListCur)
    },
    handleChange1 (key, val) {
      if (4 - key.length < 0) {
        message.info('最多选择5个关键词')
        return
      }
      this.targetKeys = key.sort()
    },
    fun_date (date) {
      let date2 = new Date()
      date2.setDate(new Date().getDate() - date)
      let time2 = date2.getFullYear().toString() + ((date2.getMonth() + 1) < 10 ? ('0' + (date2.getMonth() + 1)) : (date2.getMonth() + 1)) + ((date2.getDate()) < 10 ? ('0' + (date2.getDate())) : (date2.getDate()))//time1表示当前时间
      return time2
    },
    async removeItem1 () {
      let that = this
      await removeWordListIndex(this.currentId).then(res => {
        message.info('取消关注成功')
        that.showBtn = !that.showBtn
      })
    },
    async addItem () {
      let that = this
      let str = ''
      that.wordList.map((cur) => {
        if (cur.isFoused == 0) {
          str = str + cur.name + ','
          // that.addWordList(that.word)
        }
      })
      str = str.substring(0, str.length - 1)
      if (str == '') {
        message.info('暂无可关注的关键词')
        return
      }
      await addWordListIndex({ keyword: str }).then(res => {
        message.info('添加关注成功')
        that.showBtn = !that.showBtn
        that.getFocus()
      })
      // if(val==1){
      //     return
      // }
      // addWordListIndex({keyword:ev.currentTarget.innerText}).then(res=>{
      //     message.info('添加关注成功')
      //     that.getFocus()
      // })
    },
    removeItem (ev, val) {
      let that = this
      let str = this.word + ','
      that.curEchartsList.map((cur, index) => {
        if (cur == val) {
          that.curEchartsList.splice(index, 1)
        }
      })
      // let arr = this.word.split(',')
      // if(arr.length==1){
      //     message.info('最少保留一个关键词')
      //     return
      // }
      // arr.map((cur,index)=>{
      //     if(cur==ev.currentTarget.previousSibling.data){
      //         arr.splice(index,1)
      //     }
      // })
      this.extrWordList.map((cur, index) => {
        if (cur.text == ev.currentTarget.previousSibling.data) {
          this.extrWordList.splice(index, 1)
        }
      })
      this.extrWordList.map((cur) => {
        str = str + cur.text + ','
      })
      this.dataSource = []
      this.keyWordList = []
      this.weiboList = []
      this.wechatList = []
      this.baiduList = []
      that.targetKeys.map((_cur, _index) => {
        if (that.defaultData[_cur].title == ev.currentTarget.previousSibling.data) {
          that.targetKeys.splice(_index, 1)
        }
      })
      str = str.substring(0, str.length - 1)
      this.spinning = true;
      // this.word = arr.toString()
      this.getDetail(str, this.startDate, this.endDate,this.typeListCur)
    },
    initCharts () {
      let myChart = echarts.init(document.getElementById('main'))
      // 指定图表的配置项和数据
      let option = {
        legend: {
          data: this.legendDataList
        },
        color: this.curEchartsList,
        grid: {
          left: '2%',
          right: '2%',
          containLabel: true,
          show:'true',
          borderWidth:'0'
        },
        xAxis: {
          type: 'category',
          data: this.dataList
        },
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '10%']
          }
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          start: 0,
          backgroundColor: "#000",
          selectedDataBackground: {
            lineStyle: {
              color: "#00FF00"
            },
            areaStyle: {
              color: "#00FF00"
            }
          },
          end: 100
        }],
        yAxis: {
          type: 'value',
        },
        series: this.keyWordList
      }
      console.log('999999', option)
      myChart.setOption(option, true)
    },
    addWord () {
      let that = this
      this.targetKeys = []
      // this.mockData = this.defaultData
      this.mockData.map((cur, index) => {
        that.extrWordList.forEach(function (_cur) {
          if (_cur.text == cur.title) {
            that.targetKeys.push(cur.key)
          }
        })
      })
      this.addVisible = true
    },
    afterClose(){
        let that = this
        that.targetKeys = []
        that.mockData = that.defaultData
    },
    handleChange (val) {
      this.typeListCur = val
      this.dataSource = []
      this.keyWordList = []
      let str = ''
      str = this.word + ','
      this.extrWordList.map((cur) => {
        str = str + cur.text + ","
      })
      str = str.substring(0, str.length - 1)
      this.spinning = true;
      this.getDetail(str, this.startDate, this.endDate,this.typeListCur)
    },
    unique (arr) {
      return Array.from(new Set(arr))
    },
    uniqueArray (array, key) {
      var result = [array[0]]
      for (var i = 1;i < array.length;i++) {
        var item = array[i]
        var repeat = false
        for (var j = 0;j < result.length;j++) {
          if (item[key] == result[j][key]) {
            repeat = true
            break
          }
        }
        if (!repeat) {
          result.push(item)
        }
      }
      return result
    },
    datedifferenceDates (sDate1, sDate2) {    //sDate1和sDate2是2006-12-18格式
      sDate1 = sDate1.substring(0, 4) + '-' + sDate1.substring(4, 6) + '-' + sDate1.substring(6, 8)
      sDate2 = sDate2.substring(0, 4) + '-' + sDate2.substring(4, 6) + '-' + sDate2.substring(6, 8)
      var dateSpan,
        tempDate,
        iDays
      sDate1 = Date.parse(sDate1)
      sDate2 = Date.parse(sDate2)
      dateSpan = sDate2 - sDate1
      dateSpan = Math.abs(dateSpan)
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
      return iDays
    },
    async getTableDetail (word, startDate, endDate) {
      let that = this
      that.dataSource = []
      await getIndexDetail({
        "endDate": endDate,
        "keywords": word,
        "startDate": startDate
      }).then(res => {
        debugger
        let dataArr = []
        for (let i = 0;i < this.datedifferenceDates(endDate, startDate);i++) {
          dataArr.push(this.fun_date(i))
        }
        res.data.map((_cur, _index) => {
          that.dataSource.push({
            name: _cur.keyword,
            age: _cur.receiveData,
            weibo: _cur.微博指数 == -1 ? "0" : _cur.微博指数,
            wechat: _cur.微信指数 == -1 ? "0" : _cur.微信指数,
            address: _cur.百度指数 == -1 ? "0" : _cur.百度指数
          })
        })
      })
    },
    changePage(page){
        this.focusCurrent = page
    },
    async getDetail (word, startDate, endDate,curName) {
      let that = this
      this.dataList = []
      this.focusCurrent = 1;
      this.focusTotal = 0;
      // this.wechatList = []
      // this.weiboList = []
      // this.baiduList = []
      await getIndexDetail({
        "endDate": endDate,
        "keywords": word,
        "startDate": startDate
      }).then(res => {
        that.spinning = false
        let dataArr = []
        that.keyWordList = []
        that.curStateList = []
        for (let i = 0;i < this.datedifferenceDates(endDate, startDate);i++) {
          dataArr.push(this.fun_date(i))
        }
        word.split(',').map((cur) => {
          that.curStateList.push({
            name: cur,
            text: []
          })
          // that.weiboList.push({
          //   name: cur,
          //   text: []
          // })
          // that.baiduList.push({
          //   name: cur,
          //   text: []
          // })
        })
        let curIndex = 0
        that.focusTotal = res.data.length
        that.dataSource = res.data
        res.data.map((_cur, _index) => {
          // for(var key in _cur){　　//遍历对象的所有属性，包括原型链上的所有属性
          //   if(_cur.hasOwnProperty(key)){ //判断是否是对象自身的属性，而不包含继承自原型链上的属性
          //     if(key==curName){
          //     }
          //   }
          // }
          // that.selectColumns.map((cur1,index1)=>{
          //     cur1.dateList.push(_cur.receiveData)
          // })
          // that.dataSource.push({
          //   name: _cur.keyword,
          //   age: that.formatDate(_cur.receiveData),
          //   weibo: _cur.微博指数 == -1 ? "0" : that.formatNum(_cur.微博指数),
          //   wechat: _cur.微信指数 == -1 ? "0" : that.formatNum(_cur.微信指数),
          //   address: _cur.百度指数 == -1 ? "0" : that.formatNum(_cur.百度指数)
          // })
          that.curStateList.map((cur, index) => {
            if (cur.name == _cur.keyword) {
              //  curIndex = index
              that.curStateList[index]['text'].push(_cur[curName] == -1 ? "0" : _cur[curName])
            }
          })
          // that.weiboList.map((cur, index) => {
          //   if (cur.name == _cur.keyword) {
          //     that.weiboList[index]['text'].push(_cur.微博指数 == -1 ? "0" : _cur.微博指数)
          //   }
          // })
          // that.baiduList.map((cur, index) => {
          //   if (cur.name == _cur.keyword) {
          //     that.baiduList[index]['text'].push(_cur.百度指数 == -1 ? "0" : _cur.百度指数)
          //   }
          // })
          // that.weiboList.push(_cur.微博指数==-1?0:_cur.微博指数)
          // that.baiduList.push(_cur.百度指数==-1?0:_cur.百度指数)
          that.dataList.push(that.formatDate(_cur.receiveData))
        })
          console.log('aa',that.dataList)
        // that
        that.dataSource.reverse()
        that.dataList = that.unique(that.dataList)
        that.dataList.reverse()
        // that.dataList.map((cur, index) => {
        //   that.dataList[index] = that.formatDate(cur)
        // })
        // that.wechatList.reverse()
        // that.weiboList.reverse()
        // that.baiduList.reverse()
        word.split(',').map((cur) => {
          that.legendDataList.push(cur)
          that.keyWordList.push({
            name: cur,
            type: 'line',
            // stack: '总量',
            data: that.switchList1(cur)
          })
        })
        console.log('5555', that.keyWordList)
        // that.keyWordList.push({
        //     name: word,
        //     type: 'line',
        //     stack: '总量',
        //     data: that.switchList(curIndex)
        // })
        echarts.init(document.getElementById('main')).clear()
        that.initCharts()
      }).catch(err=>{
        that.spinning = false
      })
    },
     switchList1 (curName) {
        let arr = []
        this.curStateList.map((cur, index) => {
          if (cur.name == curName) {
            arr = cur.text
          }
        })
        return arr.reverse()
     },
    switchList (curName) {
      if (this.typeListCur == 'baiduList') {
        // return this.baiduList[curIndex].text
        let arr = []
        this.baiduList.map((cur, index) => {
          if (cur.name == curName) {
            arr = cur.text
          }
        })
        return arr.reverse()
      } else if (this.typeListCur == 'weiboList') {
        let arr = []
        this.weiboList.map((cur, index) => {
          if (cur.name == curName) {
            arr = cur.text
          }
        })
        return arr.reverse()
      } else if (this.typeListCur == 'wechatList') {
        let arr = []
        this.wechatList.map((cur, index) => {
          if (cur.name == curName) {
            arr = cur.text
          }
        })
        return arr.reverse()
      }
    },
    getFormatDate (date2) {
      return date2.getFullYear() + ((date2.getMonth() + 1) < 10 ? ('0' + (date2.getMonth() + 1)) : (date2.getMonth() + 1)) + ((date2.getDate()) < 10 ? ('0' + (date2.getDate())) : (date2.getDate()))//time1表示当前时间
    },
    formatNum (n) {
      if(n==0||n==-1){
        return '0'
      }
      let num = n.toString()
      let decimals = ''
      // 判断是否有小数
      num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
      let len = num.length
      if (len <= 3) {
        return num
      } else {
        let temp = ''
        let remainder = len % 3
        decimals ? temp = '.' + decimals : temp
        if (remainder > 0) { // 不是3的整数倍
          return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
        } else { // 是3的整数倍
          return num.slice(0, len).match(/\d{3}/g).join(',') + temp
        }
      }
    },
    getFocus () {
      let that = this
      getWordList({ pageNo: 1, pageSize: 1000 }).then(res => {
        res.rows.map((_cur) => {
          if (that.word == _cur.keyword) {
            that.currentId = _cur.id
          }
        })
      })
    }
  },
  watch: {
    // word(nVal,oVal){
    //     let that = this;
    //     that.wordList = []
    //      that.word.split(',').map((cur)=>{
    //         that.wordList.push({
    //             name:cur,
    //             isFoused:0
    //         })
    //     })
    //     if(that.wordList.length!=1){
    //         that.showBtn = false
    //     }else{
    //         that.showBtn = true
    //     }
    //     that.dataSource = [];
    //     that.keyWordList = [];
    //     that.getDetail(nVal,that.startDate,that.endDate)
    // }
  },
  mounted () {
    let that = this
    this.startDate = this.fun_date(16)
    this.endDate = this.fun_date(1)
    // this.startDate = '20210601';
    // this.endDate = '20210610';
    getInfoList().then(res=>{
      that.selectColumns = res.rows
      res.rows.map((cur,index)=>{
        that.columns.push({
          title: cur.name,
          dataIndex:  cur.name,
          sorter: true,
          align: 'right',
          key: cur.name,
          customRender: ({ text, index }) => {
            return that.formatNum(text)
          },
        })
        if(index==0){
          that.typeListCur = cur.name
        }

      })
       if (that.word != '') {
        that.word.split(',').map((cur) => {
            that.wordList.push({
              name: cur,
              isFoused: 0
            })
          })
          // this.wordList.map((cur)=>{
          that.getDetail(that.word, that.startDate, that.endDate,that.typeListCur)
          // })
        }
      console.log('333',that.selectColumns)
    })
    getWordList({ pageNo: 1, pageSize: 1000 }).then(res => {
      that.showBtn = true
      res.rows.map((cur) => {
        if (that.word == cur.keyword) {
          that.showBtn = false
          that.currentId = cur.id
        }
      })
    })
    this.value3 = [this.startDate, this.endDate]
    this.curName = this.$route.query.type == 0 ? this.word : this.$route.query.groupName
    this.curTitle = this.$route.query.type == 0 ? '关键词详情' : '组合详情'
    this.showBtn1 = this.$route.query.type == 0 ? true : false

    this.getIndex()
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/common/modal.scss';
.indexTool {
  font-family: 'NotoSansSC', sans-serif;
  .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding-bottom: 10px;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }

   /deep/.ant-spin-blur{
        opacity: .75;
    }
    /deep/.ant-spin-nested-loading > div > .ant-spin{
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        z-index: 99;
    }
    /deep/.ant-spin-container::after{
        // background-color: transparent;
        display: none;
    }
    /deep/.ant-spin{
        color: #62f662;
        font-size: 30px;
        .ant-spin-dot-item{
            background-color: #62f662;
        }
    }
  /deep/.main>div{
    max-width: 100%;
    max-height: 100%;
  }
  /deep/canvas{
    max-width: 100%!important;
    max-height: 100%!important;
  }
  .content {
    padding: 0 0 102px 0;
    background-color: #333;
    .headerContent {
      padding: 40px 152px 30px 152px;
      background-image: url('../../assets/image/ddd.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: 0 0;
      .two {
        /deep/.ant-breadcrumb-link {
          color: #fff;
        }
      }
      /deep/.ant-breadcrumb-separator {
        color: #999999;
        font-size: 14px;
      }
      /deep/.ant-breadcrumb-link a,
      /deep/.ant-breadcrumb-link,
      /deep/.ant-breadcrumb-separator {
        color: #666;
        font-size: 14px;
      }
      .tip {
        color: #fff;
        font-size: 32px;
        margin-top: 40px;
      }
      .data-list {
        display: flex;
        align-items: center;
        margin-top: 40px;
        position: relative;
        .foucus {
          float: right;
          // height: 38px;
          // line-height: 38px;
          // border: 0;
          // background-color: #00f000;
          position: absolute;
          right: 0;
          top: 50%;
          color: #333333;
          // font-size: 20px;
          transform: translateY(-50%);
          background-color: #000;
          font-size: 20px;
          color: #fff;
          transition: all 0.2s ease-in-out;
          background: linear-gradient(45deg, #00f000 50%, #000 0);
          background-size: 400% 100%;
          background-position: 100% 100%;
          transition: all 0.3s ease-out;
          &:hover {
            // background-color: #00F000;
            // border-color: #00F000;
            color: #000 !important;
            background-color: #fff !important;
            border-color: #00f000 !important;
            background-position: 0 100%;
            outline: none !important;
          }
        }
        .label {
          font-size: 20px;
          color: #fff;
          margin-right: 42px;
        }
        .list {
          // width: 106px;
          min-width: 106px;
          padding: 0 10px;
          height: 38px;
          font-size: 14px;
          cursor: pointer;
          color: #00a346;
          display: flex;
          border-radius: 6px;
          margin-right: 27px;
          align-items: center;
          justify-content: center;
          border: 1px solid #00a346;
          /deep/.anticon-close {
            color: #fff;
            margin-left: 7px;
          }
          // &:nth-child(3){
          //     color: #0056FF;
          //     border: 1px solid #0056FF;
          // }
          // &:nth-child(4){
          //     color: #FF1E68;
          //     border: 1px solid #FF1E68;
          // }
          // &:nth-child(5){
          //     color: #B3CCFF;
          //     border: 1px solid #B3CCFF;
          // }
          // &:nth-child(6){
          //     color: #B6023B;
          //     border: 1px solid #B6023B;
          // }
        }
        .last-list {
          cursor: pointer;
          // width: 130px;
          padding: 0 20px;
          height: 38px;
          font-size: 14px;
          color: #fff;
          display: flex;
          border-radius: 6px;
          margin-right: 27px;
          align-items: center;
          justify-content: center;
          border: 1px solid #fff;
        }
      }
    }
    .part {
      margin-top: 40px;
      background-color: #333333;
      padding: 0 152px;
      .part-header {
        height: 82px;
        padding: 0 32px 0 40px;
        background-color: #000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /deep/.ant-row {
          justify-content: flex-end;
          .ant-form-item-label {
            margin-right: 14px;
          }
          .ant-input {
            padding: 7px 11px;
          }
        }
        .label {
          color: #fff;
          font-size: 24px;
        }
        /deep/.ant-form-item {
          margin-bottom: 0;
          .ant-col.ant-form-item-control-wrapper {
            max-width: 60% !important;
          }
        }
        /deep/.ant-col label {
          color: #fff;
          font-size: 16px;
        }
      }
      .part-content {
        padding: 32px 37px 0;
        background-color: #fff;
        .part1 {
          /deep/.ant-select {
            width: 125px;
          }
          .dataList {
            float: right;
            display: flex;
            align-items: center;
            .share {
              width: 31px;
              height: 31px;
              cursor: pointer;
            }
            .list {
              width: 72px;
              cursor: pointer;
              height: 38px;
              border: 1px solid #666666;
              border-radius: 6px;
              color: #666666;
              font-size: 16px;
              line-height: 38px;
              text-align: center;
              margin-right: 14px;
              &.active {
                background-color: #00f000;
                color: #333333;
              }
            }
          }
        }
      }
      .main {
        width: 100%;
        height: 400px;
        margin: 20px 0;
      }
      .tableContain {
        border-top: 1px solid #c9c9c9;
        padding-top: 20px;
        margin-top: 60px;
        padding-bottom: 184px;
        /deep/.ant-table-bordered .ant-table-tbody > tr > td {
          border-color: #d9d9d9;
          border-right: 1px solid #d9d9d9;
        }
        /deep/.ant-table-thead th {
          background-color: #000;
          border: 1px solid #d9d9d9 !important;
          color: #fff;
          &:hover {
            background-color: #000;
          }
        }
        &::after {
          content: '';
          height: 0;
          line-height: 0;
          display: block;
          visibility: hidden;
          clear: both;
        }
        .downContain {
          margin-bottom: 11px;
          overflow: hidden;
          .download {
            float: right;
            width: 72px;
            height: 38px;
            line-height: 38px;
            font-weight: bold;
            text-align: center;
            color: #333333;
            font-size: 16px;
            background: #00f000;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
